import { LoadingIndicator } from "@/components/LoadingIndicator";
import { Row } from "@/components/Row";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

export const ClaimAgentOutreachDialog = ({
  candidacyId,
  isLoading,
  onOpenChange,
  onUseAgent,
  open,
  screenName,
}: {
  candidacyId: string;
  isLoading: boolean;
  onOpenChange: (open: boolean) => void;
  onUseAgent: () => void;
  open: boolean;
  screenName: MIXPANEL_SCREENS;
}) => {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent
        className="flex flex-col gap-8"
        preventOverlayClickCapturePropagation
      >
        <DialogHeader className="flex flex-col gap-4">
          <DialogTitle className="text-2xl font-semibold text-slate-700">
            Start agent outreach?
          </DialogTitle>
          <DialogDescription className="!m-0 text-base font-medium text-slate-700">
            You are claiming ownership of a candidacy in Shortlist. Would you
            like the AI scheduling agent to work on scheduling a call, or do you
            want to handle it yourself? Handling it yourself is irreversible.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            className="rounded-full"
            disabled={isLoading}
            onClick={() => {
              mixpanelUtils.trackButtonClick(
                "Claim Agent Outreach: Handle Myself",
                screenName,
                { candidacy_id: candidacyId },
              );
              onOpenChange(false);
            }}
            variant="secondary"
          >
            I will handle it myself
          </Button>
          <Button
            className="rounded-full"
            disabled={isLoading}
            onClick={() => {
              mixpanelUtils.trackButtonClick(
                "Claim Agent Outreach: Use AI Scheduling Agent",
                screenName,
                { candidacy_id: candidacyId },
              );
              onUseAgent();
            }}
          >
            {isLoading ? (
              <Row className="items-center gap-2">
                <LoadingIndicator gearColor="white" variant="small" />
                Use AI Scheduling Agent
              </Row>
            ) : (
              "Use AI Scheduling Agent"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
